import skill1 from "../assets/skill1.png";
import skill2 from "../assets/skill2.png";
import skill3 from "../assets/skill3.png";
import skill4 from "../assets/skill4.png";
import skill5 from "../assets/skill5.png";
import skill6 from "../assets/skill6.png";
import skill7 from "../assets/skill7.png";
import skill8 from "../assets/skill8.png";
import skill9 from "../assets/skill9.png";
import skill10 from "../assets/skill10.png";

const SkillCardData = [
  {
    imgsrc: skill1,
  },

  {
    imgsrc: skill2,
  },
  {
    imgsrc: skill3,
  },
  {
    imgsrc: skill4,
  },
  {
    imgsrc: skill5,
  },
  {
    imgsrc: skill6,
  },
  {
    imgsrc: skill7,
  },
  {
    imgsrc: skill8,
  },
  {
    imgsrc: skill9,
  },
  {
    imgsrc: skill10,
  },
];
export default SkillCardData;
